var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chat-bubble-square-phone--chat-bubble-square-phone-call-message"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M3.85486 1.81988C5.19961 1.66748 6.67486 1.54785 8.02813 1.54785C9.38153 1.54785 10.858 1.66751 12.2034 1.81993C13.1295 1.92484 13.8566 2.65845 13.9575 3.58506C14.1033 4.92278 14.2222 6.39653 14.2222 7.74194C14.2222 9.08768 14.1032 10.5643 13.9574 11.9036C13.8565 12.8303 13.1295 13.5639 12.2033 13.6678C10.8579 13.8188 9.38149 13.936 8.02813 13.936C6.84787 13.936 5.57484 13.8469 4.37652 13.724L1.31787 14.4522L2.02677 11.1913C1.91589 10.0528 1.83409 8.85281 1.83409 7.74194C1.83409 6.39651 1.95407 4.92275 2.10035 3.58501C2.20168 2.65845 2.92871 1.92483 3.85486 1.81988Z",
    stroke: "#353945",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    d: "M4.60836 9.0168C4.3037 9.38547 4.34538 9.93503 4.73322 10.2149C4.85747 10.3045 4.99993 10.4021 5.23967 10.5938C5.94746 11.1596 6.97231 11.1596 7.67758 10.5907C8.19822 10.1707 8.72358 9.73029 9.21586 9.23801C9.70814 8.74573 10.1485 8.22037 10.5685 7.69973C11.1375 6.99446 11.1375 5.9696 10.5717 5.26182C10.3695 5.00893 10.2733 4.86563 10.1803 4.7373C9.90925 4.36336 9.38047 4.31232 9.02132 4.60266C8.54754 4.98569 8.10817 5.44173 7.67708 5.82914C8.08733 6.27152 7.93116 6.15466 8.32191 6.57146C7.84083 7.38107 7.34416 7.87175 6.54932 8.34405C6.13185 7.95268 6.24803 8.10825 5.80491 7.6973C5.41932 8.12492 4.98785 8.55755 4.60836 9.0168Z",
    stroke: "#353945",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/contact-us.da1e2dac83ecf6f6a6d827cc248db9fb.svg";
export { ForwardRef as ReactComponent };